/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import {
  StatusFragmentDoc,
  CategoryFragmentDoc,
} from "../../../app/ProjectLabels.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type UpdateHexSelectionStatusMutationVariables = Types.Exact<{
  hexIds:
    | ReadonlyArray<Types.Scalars["HexId"]["input"]>
    | Types.Scalars["HexId"]["input"];
  statusId: Types.InputMaybe<Types.Scalars["StatusId"]["input"]>;
}>;

export type UpdateHexSelectionStatusMutation = {
  readonly __typename: "Mutation";
  readonly batchUpdateHexStatus: ReadonlyArray<{
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly status: {
      readonly __typename: "Status";
      readonly enforcesReview: boolean;
      readonly id: c.StatusId;
      readonly name: string;
      readonly color: Types.HexColor;
      readonly description: string | null;
      readonly inLibrary: boolean;
      readonly endorsed: boolean;
      readonly icon: Types.IconType | null;
    } | null;
  }>;
};

export const UpdateHexSelectionStatusDocument = /*#__PURE__*/ gql`
  mutation UpdateHexSelectionStatus($hexIds: [HexId!]!, $statusId: StatusId) {
    batchUpdateHexStatus(hexIds: $hexIds, statusId: $statusId) {
      id
      status {
        ...StatusFragment
        enforcesReview
      }
    }
  }
  ${StatusFragmentDoc}
`;
export type UpdateHexSelectionStatusMutationFn = Apollo.MutationFunction<
  UpdateHexSelectionStatusMutation,
  UpdateHexSelectionStatusMutationVariables
>;

/**
 * __useUpdateHexSelectionStatusMutation__
 *
 * To run a mutation, you first call `useUpdateHexSelectionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHexSelectionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHexSelectionStatusMutation, { data, loading, error }] = useUpdateHexSelectionStatusMutation({
 *   variables: {
 *      hexIds: // value for 'hexIds'
 *      statusId: // value for 'statusId'
 *   },
 * });
 */
export function useUpdateHexSelectionStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateHexSelectionStatusMutation,
    UpdateHexSelectionStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateHexSelectionStatusMutation,
    UpdateHexSelectionStatusMutationVariables
  >(UpdateHexSelectionStatusDocument, options);
}
export type UpdateHexSelectionStatusMutationHookResult = ReturnType<
  typeof useUpdateHexSelectionStatusMutation
>;
export type UpdateHexSelectionStatusMutationResult =
  Apollo.MutationResult<UpdateHexSelectionStatusMutation>;
export type UpdateHexSelectionStatusMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateHexSelectionStatusMutation,
    UpdateHexSelectionStatusMutationVariables
  >;
